const initUser = {
  users: [],
  user: {},
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  isFormLoading: false,
};

export const userReducer = (state = initUser, action: any) => {
  if (action.type === "SET_USER") {
    return {
      ...state,
      users: action.value,
    };
  }
  if (action.type === "SET_USER_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_USER_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_USER") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_FORM_LOADING") {
    return {
      ...state,
      isFormLoading: action.value,
    };
  }
  if (action.type === "SET_USER_DETAIL") {
    return {
      ...state,
      user: action.value,
    };
  }
  return state;
};
